export enum AgentType {
  singleAgent = 'Single Agent',
  coListing = 'Co-Listing',
  team = 'Team',
}
